import React from 'react';
import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

export default function GuardianAuthModal({ open, onClose, onSelectMode }) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      aria-labelledby="guardian-auth-dialog-title"
    >
      <DialogTitle id="guardian-auth-dialog-title" sx={{ pr: 6, fontWeight: 600 }}>
        Sign in to continue
        <IconButton
          aria-label="Close"
          onClick={onClose}
          sx={{ position: 'absolute', right: 8, top: 8, color: 'text.secondary' }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ pb: 3, pt: 1 }}>
        <Button
          fullWidth
          variant="contained"
          size="large"
          onClick={() => onSelectMode('login')}
          sx={{ textTransform: 'none', py: 1.25 }}
        >
          Sign in
        </Button>
        <Typography
          variant="body2"
          sx={{ mt: 3, mb: 2, textAlign: 'center', lineHeight: 1.5, color: 'text.secondary' }}
        >
          New here? Create an account to get started.
        </Typography>
        <Button
          fullWidth
          variant="outlined"
          size="large"
          onClick={() => onSelectMode('register')}
          sx={{ textTransform: 'none', py: 1.25 }}
        >
          Sign up
        </Button>
      </DialogContent>
    </Dialog>
  );
}
